import {createContext} from 'react'

const CatTipoCobroContext = createContext()

export default CatTipoCobroContext